import { NgxLoggerLevel } from 'ngx-logger';
import { EnvironmentInterface } from './environment.interface';

export const environment: EnvironmentInterface = {
  production: false,
  level: NgxLoggerLevel.INFO,
  serverLogLevel: NgxLoggerLevel.INFO,
  disableConsoleLogging: true,
  applicationName: 'CAAKS',
  applicationTitle: 'CAAKS',
  applicationVersion: '2.0.0',
  // AWS Config
  globalRegion: 'eu-west-3',
  apiRegion: 'eu-west-3',
  apiEnpoints: {
    administrationApi: {
      baseUrl: 'https://hom-administration.dir.istefr.fr/api/v1',
      authType: 'bearer',
      apiKey: '',
    },
    clientApi: {
      baseUrl: 'https://hom-client-account.dir.istefr.fr/api/v1',
      authType: 'bearer',
      apiKey: '',
    },
    tenantApi: {
      baseUrl: 'https://hom-tenant-account.dir.istefr.fr/api/v1',
      authType: 'bearer',
      apiKey: '',
    },
    serviceCatalogApi: {
      baseUrl: 'https://hom-service-catalog.dir.istefr.fr/api/v1',
      authType: 'bearer',
      apiKey: '',
    },
    serviceDeploymentApi: {
      baseUrl: 'https://hom-service-deployment.dir.istefr.fr/api/v1',
      authType: 'bearer',
      apiKey: '',
    },
    subscriptionApi: {
      baseUrl: 'https://hom-service-subscription.dir.istefr.fr/api/v1',
      authType: 'bearer',
      apiKey: '',
    },
    referentielApi: {
      baseUrl: 'https://dev.api.eau.veolia.fr/sbvp/v1',
      authType: 'apikey',
      apiKey: 'e9e2v3eEHaVuGuwtlzJoa1TIStrgBDMKsK4AWD2Ta12pIWiD',
      apiKeyName: 'apiKey',
    },
    iamApi: {
      baseUrl: 'https://hom-service-iam.dir.istefr.fr/api/v1',
      authType: 'bearer',
      apiKey: '',
    },
  },
  tenantId: 'sbvp',
  // Auth provider configuration
  auth: {
    oidc: {
      authority: 'https://ciam-ileo-hom.mel-ileo.fr/realms/sbvp',
      clientId: 'hom-sbvp-from',
      issuer: 'https://ciam-ileo-hom.mel-ileo.fr/realms/sbvp',
      redirectUri: window.location.origin,
      scope: 'openid profile email',
      responseType: 'code',
      silentRenew: true,
      postLogoutRedirectUri: window.location.origin,
      autoUserinfo: true,
      logLevel: 'DEBUG',
    },
    loginRedirectUri: window.location.origin,
    logoutRedirectUri: window.location.origin,
    provider: 'oidc',
    federatedSignInProvider: 'ciam-ileo-hom.mel-ileo.fr/realms/sbvp',
    postLoginRedirectPath: '/sbvp/customers',
  },
  config: {
    main_menu: [
      {
        path: '/sbvp/customers',
        title: 'Clients',
        type: 'link',
        icontype: 'organization',
        collapse: 'components',
        roles: ['admin_sbvp', 'admin_application', 'customer'],
      },
      {
        path: '/sbvp/subscriptions/list',
        title: 'Souscriptions',
        type: 'link',
        icontype: 'applications',
        roles: ['admin_sbvp', 'admin_application', 'customer'],
      },
      {
        path: '/sbvp/catalog/apps',
        title: 'Catalogue de services',
        type: 'link',
        icontype: 'applications',
        roles: ['admin_sbvp', 'admin_application', 'developer_application'],
      },
      {
        path: '/sbvp/admin',
        title: 'Administration',
        type: 'sub',
        icontype: 'cog',
        roles: ['admin_sbvp'],
        children: [
          {
            path: 'requests',
            title: 'Demandes',
            type: 'link',
          },
          {
            path: 'users',
            title: 'Utilisateurs',
            type: 'link',
          },
          {
            path: 'organizations/import',
            title: 'Import organisation',
            type: 'link',
          },
        ],
      },
    ],
  },
};
